import { useMemo } from 'react';
import { useChatSessions } from './useChatSessions';
import { useParams } from 'react-router-dom';

export function useChatWithUser(userId) {
    const { eventId } = useParams(),
        filter = eventId ? (s) => s.eventId == eventId : null,
        chatSessions = useChatSessions({ filter });

    return useMemo(() => {
        return chatSessions.find((cs) => cs.userId == userId || cs.otherUserId == userId);
    }, [chatSessions, userId]);
}
